<form #howForm="ngForm" class="app-form" novalidate>
  <vue-panel [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" titleKey="RetrieveUserComponent.VerifyYourIdentity" class="app-container">
    <div id="retrieveUser">
      {{ 'RetrieveUserComponent.MandatoryFields' | translate: ACCOUNT_RECOVERY_BUNDLE_NAME | async }}
      <vue-control-group [control]="retrievalType" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="RetrieveUserComponent.WhatDoYouRemember" excludeValidationMessage="true">
        <mat-radio-group #inputElement class="cust-mat-radio-group" name="searchType" [(ngModel)]="userSearchType" vueRequired (change)="resetForm()">
          @if (retrievalType === retrievalTypeEnum.PASSWORD) {
            <mat-radio-button id="byUsername" [value]="userSearchTypeEnum.USERNAME">
              {{ translations.byUsername }}
            </mat-radio-button>
          }
          <mat-radio-button id="byProfile" [value]="userSearchTypeEnum.PROFILE">
            {{ translations.byProfile }}
          </mat-radio-button>
          <mat-radio-button id="byIdentity" [value]="userSearchTypeEnum.IDENTITY">
            {{ translations.byIdentity }}
          </mat-radio-button>
        </mat-radio-group>
      </vue-control-group>

      @switch (userSearchType) {
        @case (userSearchTypeEnum.USERNAME) {
          <div id="retrieveByUsername">
            <vue-control-group [control]="usernameField" excludeValidationMessage="true" widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="label.username">
              <input #inputElement name="usernameField" class="form-control"  vueMaxLength="40" id="usernameField"
                [(ngModel)]="user.userName" vueRequired #usernameField="ngModel" autocomplete="off">
                <vue-validation-message [control]="usernameField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" vueValidateLength='error.MaxLength'>
                </vue-validation-message>
              </vue-control-group>
            </div>
          }
          @case (userSearchTypeEnum.PROFILE) {
            <div id="retrieveByProfile">
              <vue-control-group [control]="firstNameField" excludeValidationMessage="true" widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="label.FirstName">
                <input #inputElement name="firstNameField" class="form-control"  vueMaxLength="30" id="firstNameField"
                  [(ngModel)]="user.firstName" vueRequired #firstNameField="ngModel" autocomplete="off">
                  <vue-validation-message [control]="firstNameField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" vueValidateLength='error.MaxLength'>
                  </vue-validation-message>
                </vue-control-group>
                <vue-control-group [control]="lastNameField" excludeValidationMessage='true' widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="label.LastName">
                  <input #inputElement name="lastNameField" class="form-control"  vueMaxLength="50" id="lastNameField"
                    [(ngModel)]="user.lastName" vueRequired #lastNameField="ngModel" autocomplete="off">
                    <vue-validation-message [control]="lastNameField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" vueValidateLength='error.MaxLength'>
                    </vue-validation-message>
                  </vue-control-group>
                  <vue-control-group [control]="emailField" excludeValidationMessage='true' widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="label.EmailAddress">
                    <input #inputElement name="emailField" class="form-control" vueMaxLength="255" minlength="6" id="emailField"
                      pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_'`{|}~-]+@(([A-Za-z0-9]+\.)|([A-Za-z0-9]+[A-Za-z0-9\-]+[A-Za-z0-9]+\.))+[A-Za-z0-9]+([A-Za-z0-9]*)$"
                      [(ngModel)]="user.email" vueRequired #emailField="ngModel" autocomplete="off">
                      <vue-validation-message [control]="emailField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
                        vueValidateLength='error.MaxLength'
                        minlength='error.EmailMinLength'
                        pattern="error.EmailRequiredPattern"
                        [isSingleFieldLevelErrorEnabled]="true"
                        singleFieldLevelErrorPriority="vueValidateLength">
                      </vue-validation-message>
                    </vue-control-group>
                  </div>
                }
                @case (userSearchTypeEnum.IDENTITY) {
                  <div id="retrieveByIdentity">
                    <vue-control-group [control]="ccidField" excludeValidationMessage='true' widthClass="shorter" [formError]="formError" [label]="client.ccidFieldName">
                      <input #inputElement name="ccidField" class="form-control"  vueMaxLength="50" id="ccidField"
                        [(ngModel)]="user.clientStudentID" vueRequired #ccidField="ngModel" autocomplete="off">
                        <vue-validation-message [control]="ccidField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" vueValidateLength='error.MaxLength'>
                        </vue-validation-message>
                      </vue-control-group>
                      <vue-control-group [control]="emailField" excludeValidationMessage='true' widthClass="shorter" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME" labelKey="label.EmailAddress">
                        <input #inputElement name="emailField" class="form-control"  vueMaxLength="255" minlength="6" id="emailField"
                          pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_'`{|}~-]+@(([A-Za-z0-9]+\.)|([A-Za-z0-9]+[A-Za-z0-9\-]+[A-Za-z0-9]+\.))+[A-Za-z0-9]+([A-Za-z0-9]*)$"
                          [(ngModel)]="user.email" vueRequired #emailField="ngModel" autocomplete="off">
                          <vue-validation-message [control]="emailField" [formError]="formError" [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
                            vueValidateLength='error.MaxLength'
                            minlength='error.EmailMinLength'
                            pattern="error.EmailRequiredPattern"
                            [isSingleFieldLevelErrorEnabled]="true"
                            singleFieldLevelErrorPriority="vueValidateLength">
                          </vue-validation-message>
                        </vue-control-group>
                      </div>
                    }
                  }

                  <vue-form-buttons
                    [i18nBundle]="ACCOUNT_RECOVERY_BUNDLE_NAME"
                    secondaryLabelKey="button.ReturnToLogin"
                    primaryLabelKey="{{retrievalType === retrievalTypeEnum.PASSWORD ? 'button.Next' : 'button.Submit'}}"
                    (secondaryButtonClicked)="previousAction()"
                    (primaryButtonClicked)="submit()">
                  </vue-form-buttons>
                </div>
              </vue-panel>
            </form>
